var Theme = Theme || {};

Theme.BookAbstract = (function ($) {

    return {
        init: _init
    };

    function _init() {
        initBookAbstractClickEvent();
    }

    function initBookAbstractClickEvent() {
        $('.master-main').on('click', '.js-showBookAbstractLink', handleClickEvent);
    }

    function handleClickEvent(e) {
        var $currTarget = $(e.currentTarget);
        var $wrapperDiv = $currTarget.closest('[data-book-abstract-to-be-fetched-wrapper]');
        var bookId = $wrapperDiv.attr('data-bookid-abstract');
        var $triedFetchDiv = $wrapperDiv.children('[data-tried-to-fetch-abstract]').first();
        var triedFetch = $triedFetchDiv.attr('data-tried-to-fetch-abstract') === 'true';
        var $abstractLocation = $(`#abstract-${bookId}`);
        var $baseSiteUrl = $('#hfSiteURL');
        var $abstractLinks = $(`#abstract-${bookId}-links`);
        var ajaxUrl = $currTarget.parent().attr('data-link-book-abstract-type') == 'extract' ? '/Book/BookAbstractOrExtractAjax' : '/PlatformBook/BookAbstractAjax';
        var ajaxData = {
            bookId: bookId
        };

        if ($baseSiteUrl && $baseSiteUrl.val()) {
            ajaxUrl = '//' + $baseSiteUrl.val() + ajaxUrl;
        }

        $abstractLocation.closest('li').toggleClass('abstractExpanded');
        $abstractLocation.toggleClass('hide');
        _toggleAriaExpanded();

        if (!triedFetch) {
            _fetchBookAbstract();
            $triedFetchDiv.attr('data-tried-to-fetch-abstract', 'true');
        }

        function _fetchBookAbstract() {
            SCM.Ajax.get(ajaxUrl, ajaxData)
                .expectActionResultModel()
                .then(_populateBookAbstractDropdown)
                .catch(console.error);
        }

        function _populateBookAbstractDropdown(ajaxResponse) {
            $abstractLocation.html(ajaxResponse.Html);
            $abstractLocation.append($abstractLinks.html());
            SCM.Utilities.LazyLoad.init('lazy');
        }

        function _toggleAriaExpanded() {
            $currTarget.attr('aria-expanded', $currTarget.attr('aria-expanded') === 'false' ? 'true' : 'false');
        }

        var $thisAbstractIcon = $wrapperDiv.find('.abstract-toggle-icon');
        var $downArrow = 'icon-general-arrow-filled-down';
        var $upArrow = 'icon-general-arrow-filled-up';

        $thisAbstractIcon.hasClass($downArrow) ? $thisAbstractIcon.removeClass($downArrow).addClass($upArrow) : $thisAbstractIcon.removeClass($upArrow).addClass($downArrow);

    }

})(jQuery);
